<div class="login-page-container">
  <div class="login-container" id="login-container">
    <!-- svg logo -->
    @if (!isNovacoopEnv) {
      <div class="logo">
        <img src="assets/icons/is_icons/rebecca_logo.svg" />
      </div>
    }

    <!-- svg novacoop logo -->
    @if (isNovacoopEnv) {
      <div class="logo" style="padding-bottom: 20px">
        <img src="assets/icons/is_icons/novacoop_logo.svg" />
      </div>
    }

    <!-- motto (subtitle) section -->
    @if (!isNovacoopEnv) {
      <div class="motto is-h6">
        {{ 'motto' | translate }}
      </div>
    }

    <form class="login-form-container" [formGroup]="loginForm" autocomplete="on" (ngSubmit)="submit()">
      <mat-form-field appearance="outline" class="mb--20">
        <input
          matInput
          type="text"
          name="username"
          class="is-h6"
          placeholder="Username"
          formControlName="username"
          autocomplete="username" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input
            matInput
            [type]="showPassword ? 'text' : 'password'"
            name="password"
            class="is-h6"
            placeholder="Password"
            formControlName="password"
            autocomplete="current-password" />
            @if (typingPassword) {
              <mat-icon
                matSuffix
                style="cursor: pointer"
                [svgIcon]="showPassword ? 'visibility_off' : 'visibility'"
                color="primary"
                (click)="changeShowPassword()"
                [ngClass]="showPassword ? 'show-password' : null"
                matTooltip="{{ (showPassword ? 'hide_password' : 'show_password') | translate }}">
              </mat-icon>
            }
          </mat-form-field>
          <button
            mat-flat-button
            type="submit"
            color="primary"
            class="clickable is-button"
            [disabled]="showSpinner || !loginForm?.valid">
            @if (!showSpinner) {
              <span>LOGIN</span>
            }
            @if (showSpinner) {
              @if (showSpinner) {
                <div class="spinner-login">
                  <mat-spinner [diameter]="30"></mat-spinner>
                </div>
              }
            }
          </button>
          @if (infoAuth.enabled) {
            <button
              mat-flat-button
              color="primary"
              class="clickable is-button"
              (click)="navigateExternalAuth()"
              >
              {{ infoAuth.button_text | uppercase }}
            </button>
          }
        </form>
      </div>
    </div>
